import moment from 'moment';

import { getMix } from '../api';
import logger from '../utils/logger';

export const MIX_LOAD_ACTION = 'MIX_LOAD_ACTION';
export const MIX_RECEIVE_ACTION = 'MIX_RECEIVE_ACTION';

function loadMixAction({ date }) {
  return { type: MIX_LOAD_ACTION, date };
}

function receiveMixAction({ date, data, errors }) {
  return { type: MIX_RECEIVE_ACTION, date, data, errors };
}

const initialState = {};
function mixReducer(state = initialState, action) {
  const { type } = action;
  switch (type) {
    case MIX_LOAD_ACTION: {
      const key = moment(action.date).format('YYYY-MM-DD');
      console.log('[mixReducer] Handling MIX_LOAD_ACTION for date:', key);
      return {
        ...state,
        [key]: {
          loading: true,
          loaded: false,
          errors: null,
          data: [],
        },
      };
    }
    case MIX_RECEIVE_ACTION: {
      const key = moment(action.date).format('YYYY-MM-DD');
      console.log(
        '[mixReducer] Handling MIX_RECEIVE_ACTION for date:',
        key,
        'with data:',
        action.data,
      );
      return {
        ...state,
        [key]: {
          loading: false,
          loaded: !action.errors,
          errors: action.errors || null,
          data:
            action.errors || !action.data || !action.data.mix
              ? []
              : action.data.mix,
        },
      };
    }
    default:
      return state;
  }
}

export function mixLoadedSelector({ date: inputDate }, state) {
  const date = moment(inputDate).format('YYYY-MM-DD');
  if (!state.mix) {
    console.warn('[mixLoadedSelector] state.mix is undefined');
    return false;
  }
  return state.mix[date] && state.mix[date].loaded;
}

export function mixErrorSelector({ date: inputDate }, state) {
  const date = moment(inputDate).format('YYYY-MM-DD');
  if (!state.mix) {
    console.warn('[mixErrorSelector] state.mix is undefined');
    return null;
  }
  return state.mix[date] && state.mix[date].errors;
}

export function mixSelector({ date: inputDate }, state) {
  const date = moment(inputDate).format('YYYY-MM-DD');
  console.log('[mixSelector] State structure:', state);
  if (!state.mix || !state.mix[date]) {
    console.warn(
      '[mixSelector] No mix data for date:',
      date,
      'state.mix:',
      state.mix,
    );
    return [];
  }
  console.log(
    '[mixSelector] Returning mix data for date:',
    date,
    'data:',
    state.mix[date].data,
  );

  console.log('Mix data:', state.mix[date].data);

  return state.mix[date].data;
}

export function loadAllMix({ date: inputDate }) {
  const date = moment(inputDate).format('YYYY-MM-DD');
  return function dispatchLoadAllMix(dispatch, getState) {
    if (mixLoadedSelector({ date }, getState())) {
      console.log('[loadAllMix] Mix already loaded for date:', date);
      return Promise.resolve();
    }

    console.log('[loadAllMix] Dispatching loadMixAction for date:', date);
    dispatch(loadMixAction({ date }));
    return getMix({ date })
      .then(data => {
        console.log(
          '[loadAllMix] Dispatching receiveMixAction with data:',
          data,
        );
        return dispatch(
          receiveMixAction({
            date,
            data,
          }),
        );
      })
      .catch(errors => {
        console.error('[loadAllMix] Failed to load mix data:', errors);
        return dispatch(receiveMixAction({ date, errors }));
      });
  };
}

export default mixReducer;
